import { expose, normalizeModulePath } from 'live/expose'

const req = require.context(
    './',
    true,
    /^(?!.*__tests__.*)^(?!.*\.stories\.*)^(?!.*Spec.js)^(?!.*worker.js)^(?!.*__mocks__.*\.js)((.*\.([t|j]sx?\.*))[^.]*$)/
)

function exposeRequireContext(requireContext, modulePrefix = '') {
    const modules = {}
    requireContext.keys().forEach(path => {
        const pathName = modulePrefix + normalizeModulePath(path)
        const mod = requireContext(path)
        modules[pathName] = mod

        if (/[^"]+?\/index\.(j|t)sx?/g.test(path)) {
            modules[pathName.replace(/(.*)\/index$/, '$1')] = mod
        }
    })

    expose(modules)
}

exposeRequireContext(req, 'plugin-codaf-risk-ext-bowtie/shared/')
